import styles from "./reportsPage.module.css";

import { useEffect, useState } from "react";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { useParams } from "react-router";
import { DeleteIcon, SaveIcon } from "../../../assets/icons";
import { Button } from "../../../components/button/button";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { Separator } from "../../../components/separator/separator";
import { getDateWithYear } from "../../../utils/getStrDate";
import CheckListAPI from "../../../api/CheckListAPI";
import { useConfirmPopup } from "../../../components/popup/confirmPopup/confirmPopup";
import { downloadFile } from "../../../utils/downloadFile";

import { Text } from "../../../components/text/text";

export const CafeReportsPage = () => {
    const { cafeId } = useParams();

    const [files, setFiles] = useState([]);
    const openPage = useOpenPage();

    useEffect(() => {
        CheckListAPI
            .fetchCafeReportsList(cafeId)
            .then(setFiles)
            .catch(console.error);
    }, [cafeId]);

    const onDownload = (report) => {
        CheckListAPI
            .fetchCafeReportDownloadLink(cafeId, report.id)
            .then((res) => downloadFile(res, report.filename))
            .catch(console.error);
    }

    const [forDelete, setForDelte] = useState(null);
    const onDelete = (id) => {
        CheckListAPI
            .deleteCafeReport(cafeId, id)
            .then(() => setFiles(prev => prev.filter(el => el.id !== id)))
            .catch(console.error);
    }

    const [DeletePopup, open] = useConfirmPopup(
        "Подтвердите действие",
        "Вы уверены, что хотите удалить отчет?",
        () => onDelete(forDelete)
    )

    return (
        <>
            <AdminHeader
                title="Отчеты"
            />

            {
                files && files.length > 0 ?
                    <div className={styles.files}>
                        {
                            files.map(data => (
                                <div className={styles.file} key={data.id}>
                                    <div className={styles.file_header}>
                                        <DeleteIcon onClick={() => {
                                            open();
                                            setForDelte(data.id);
                                        }} />
                                        <SaveIcon onClick={() => onDownload(data)} />
                                    </div>
                                    <Text as="div" variant="body" className={styles.period} size={12}>
                                        {getDateWithYear(new Date(data.periodStart))} - {getDateWithYear(new Date(data.periodEnd))}
                                    </Text>
                                    <Text as="div" variant="body" className={styles.file_name} size={14} weight={700}>{data.objectName}</Text>
                                </div>
                            ))
                        }
                    </div>
                    :
                    <div
                        style={
                            {
                                fontSize: "16px",
                                flex: "1 1 auto",
                                textAlign: "center",
                                marginTop: "10px",
                                color: "var(--app-secondary-text-color)",
                            }
                        }
                    >
                        Отчетов пока нет...
                    </div>
            }

            <Separator />

            <Button
                fixed
                text="Сгенерировать отчет"
                onClick={openPage(`create`)}
            />

            {DeletePopup}
        </>
    );
}